import { YOO_FINDS_CDN } from "@/common";

export const WINTER_BANNER = `${YOO_FINDS_CDN}/pc/winter/winter_banner.png`;

export const WINTER_BG = `${YOO_FINDS_CDN}/pc/winter/bg.png`;
